import { connectionState, templateState } from '@/shared/Status'
import { getFormatMessage, mergeTableColumns } from '@/utils/utils'
import { EllipsisOutlined, ExclamationCircleOutlined } from '@ant-design/icons'
import { Badge, Button, Dropdown, Menu, Space, Table, Tooltip } from 'antd'
import moment from 'moment'
import React from 'react'
import { BoxItem, BoxTableProps } from '../interface'

export const BoxTable: React.FC<BoxTableProps> = (props: BoxTableProps) => {
  const { onMenuItemClick } = props
  const formatMessage = getFormatMessage()

  // const deleteItem = (item: BoxItem) => {
  //   confirm({
  //     title: formatMessage({ id: 'app.modal.confirm.delete' }),
  //     icon: <ExclamationCircleOutlined />,
  //     okText: formatMessage({ id: 'app.modal.ok' }),
  //     cancelText: formatMessage({ id: 'app.modal.cancel' }),
  //     onOk() {
  //       if (props.onDelete) {
  //         props.onDelete(item)
  //       }
  //     }
  //   })
  // }

  const menu = (record: BoxItem) => (
    <Menu>
      <Menu.Item
        key='contextmenu.firmware'
        disabled={record.connectionState != 1}
        onClick={() => onMenuItemClick?.('firmware', record)}
      >
        {formatMessage({ id: 'app.box.toolbar.batch.firmware' })}
      </Menu.Item>
      <Menu.Item
        key='contextmenu.template'
        disabled={record.connectionState != 1}
        onClick={() => onMenuItemClick?.('template', record)}
      >
        {formatMessage({ id: 'app.box.toolbar.batch.template' })}
      </Menu.Item>
      <Menu.Item
        key='contextmenu.clean'
        disabled={record.connectionState != 1}
        onClick={() => onMenuItemClick?.('clean', record)}
      >
        {formatMessage({ id: 'app.box.toolbar.batch.clean' })}
      </Menu.Item>
      {/**
       * todo: 当前版本移除透传入口
       */}
      {/* <Menu.Item
        key='contextmenu.tunnel'
        disabled={record.connectionState != 1}
        onClick={() => onMenuItemClick?.('tunnel', record)}
      >
        {formatMessage({ id: 'app.box.toolbar.batch.tunnel' })}
      </Menu.Item> */}
      <Menu.Item
        key='contextmenu.reboot'
        disabled={record.connectionState != 1}
        onClick={() => onMenuItemClick?.('reboot', record)}
      >
        {formatMessage({ id: 'app.box.toolbar.batch.reboot' })}
      </Menu.Item>
    </Menu>
  )
  const defaultColumns = [
    {
      title: formatMessage({ id: 'app.box.table.index' }),
      key: 'app.box.table.index',
      dataIndex: 'index',
      render: (text: any, record: any, index: any) => index + 1
    },
    {
      title: formatMessage({ id: 'app.box.table.alias' }),
      key: 'app.box.table.alias',
      dataIndex: 'alias'
    },
    {
      title: formatMessage({ id: 'app.box.table.boxNo' }),
      key: 'app.box.table.boxNo',
      dataIndex: 'boxNo'
    },
    {
      title: formatMessage({ id: 'app.box.table.connectionState' }),
      key: 'app.box.table.connectionState',
      dataIndex: 'connectionState',
      render: (text: any, record: any, index: any) => (
        <span>
          <Badge status={connectionState[record.connectionState].color} />
          {connectionState[record.connectionState].text}
        </span>
      )
    },
    {
      title: formatMessage({ id: 'app.box.table.templateState' }),
      key: 'app.box.table.templateState',
      dataIndex: 'templateState',
      render: (text: any, record: any, index: any) => (
        <span>
          <Badge status={templateState[record.templateState].color} />
          {templateState[record.templateState].text}
          {record.templateCode > 0 && (
            <Tooltip
              title={formatMessage({
                id: `app.template.code.${record.templateCode}`
              })}
            >
              <ExclamationCircleOutlined
                style={{ marginLeft: 5, cursor: 'pointer' }}
              />
            </Tooltip>
          )}
        </span>
      )
    },
    {
      title: formatMessage({ id: 'app.box.table.boxType' }),
      key: 'app.box.table.boxType',
      dataIndex: 'boxType',
      render: (text: any, record: any, index: any) => {
        if (record.boxType !== undefined || record.boxType !== null) {
          if (
            record.subType !== undefined &&
            record.subType !== null &&
            record.subType !== 1
          ) {
            return (
              formatMessage({ id: `app.boxType.${record.boxType}` }) +
              '-' +
              formatMessage({ id: `app.subType.${record.subType}` })
            )
          }
          return formatMessage({ id: `app.boxType.${record.boxType}` })
        }
        return '-'
      }
    },
    {
      title: formatMessage({ id: 'app.box.table.templateName' }),
      key: 'app.box.table.templateName',
      render: (text: any, record: any, index: any) =>
        record.template && record.template.name
    },
    {
      title: formatMessage({ id: 'app.box.table.plcCount' }),
      key: 'app.box.table.plcCount',
      render: (text: any, record: BoxItem, index: any) => {
        if (record.template && record.template.plcs) {
          if (Array.isArray(record.template.plcs)) {
            return record.template.plcs.length
          }
          return record.template.plcs
        }
        return ''
      }
    },
    {
      title: formatMessage({ id: 'app.box.table.variableCount' }),
      key: 'app.box.table.variableCount',
      render: (text: any, record: BoxItem, index: any) => {
        if (record.template && record.template.variables) {
          if (Array.isArray(record.template.variables)) {
            return record.template.variables.length
          }
          return record.template.variables
        }
        return ''
      }
    },
    {
      title: formatMessage({ id: 'app.box.table.networkType' }),
      key: 'app.box.table.networkType',
      dataIndex: 'networkType',
      render: (text: any, record: any, index: any) =>
        formatMessage({ id: `app.networkType.${text}` })
    },
    {
      title: formatMessage({ id: 'app.box.table.lastOffline' }),
      key: 'app.box.table.lastOffline',
      render: (text: string, record: BoxItem, index: number) => {
        return record.connectionState !== 1 && record.lastOffline
          ? moment(record.lastOffline).local().format('YYYY-MM-DD HH:mm:ss')
          : '-'
      }
    },
    {
      title: formatMessage({ id: 'app.box.table.operation' }),
      key: 'app.box.table.operation',
      render: (text, record: BoxItem) => (
        <Space size='middle'>
          <Button
            style={{ padding: '0px 0px' }}
            type='link'
            onClick={() => onMenuItemClick?.('detail', record)}
          >
            {formatMessage({ id: 'app.box.table.operation.detail' })}
          </Button>
          <Button
            style={{ padding: '0px 0px' }}
            type='link'
            onClick={() => onMenuItemClick?.('edit', record)}
          >
            {formatMessage({ id: 'app.box.table.operation.edit' })}
          </Button>
          <Button
            style={{ padding: '0px 0px' }}
            type='link'
            onClick={() => onMenuItemClick?.('delete', record)}
          >
            {formatMessage({ id: 'app.box.table.operation.delete' })}
          </Button>
          <Dropdown overlay={menu(record)}>
            <a
              className='ant-dropdown-link'
              onClick={(e) => e.preventDefault()}
            >
              <EllipsisOutlined />
            </a>
          </Dropdown>
        </Space>
      )
    }
  ]

  const columns = mergeTableColumns(defaultColumns, props.columns)
  const rowSelection = {
    onChange: (selectedRowKeys: React.Key[], selectedRows: any[]) => {
      if (props.onSelect) {
        props.onSelect(selectedRows)
      }
    }
  }

  return (
    <Table
      rowKey='id'
      columns={columns}
      dataSource={props.data}
      rowSelection={
        props.selectable
          ? {
              type: props.selectionType,
              ...rowSelection
            }
          : undefined
      }
      pagination={props.pagination}
    />
  )
}
